import { ICreatorTheme } from "../../../../../features/Common/modules/Theme/theme.interface";
import { getColorsFromCreatorTheme } from "../../../../../features/Common/modules/Theme/utils/Theme.utils";
import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    replyTextAreaContainer: {},
    showRepliesButton: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      margin: "8px 5px 8px -8px !important",
    },
  },
  componentName: "CommentWithReplies",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  const { color1 } = getColorsFromCreatorTheme(theme);
  return getStylesObjFromCss({
    styles: {
      showRepliesButton: {
        color: (color1 || "#493AB1") + " !important",
      },
    },
    componentName: "CommentWithReplies",
  });
};
